var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 60.4148,14.955292 C 55.1776,9.5084123 47.8895,6.0075123 39.8084,5.6811703 c -2.0288,-0.081972 -3.7406,1.496562 -3.8226,3.524662 -0.082,2.0288697 1.4966,3.7406397 3.5238,3.8236397 6.1305,0.24964 11.6212,2.88841 15.6079,7.02551 3.9813,4.1417 6.4185,9.7345 6.4204,15.9333 -0.0019,6.3574 -2.5667,12.0788 -6.7303,16.2497 -4.1708,4.1645 -9.893,6.7284 -16.2494,6.7302 -6.3566,-0.002 -12.0806,-2.5658 -16.2497,-6.7302 -4.1635,-4.1709 -6.7284,-9.8921 -6.7302,-16.2497 0,-0.4475 0.0136,-0.8914 0.0388,-1.3316 l 4.3801,2.162 c 0.4756,0.2343 1.0281,0.2379 1.4583,0.011 0.4319,-0.2297 0.6872,-0.66 0.6763,-1.143 l -0.432,-19.251 c -0.0146,-0.5506 -0.37,-1.0737 -0.9114,-1.3445 -0.545,-0.26604 -1.1777,-0.23238 -1.6206,0.0949 l -15.5444264,11.364 c -0.391871,0.2854 -0.5779141,0.7492 -0.4959422,1.2305 0.078374,0.4829 0.4174402,0.9177 0.8950092,1.153 l 4.589649,2.265 c -0.24887,1.5631 -0.38776,3.1609 -0.38776,4.7897 -0.00179,8.3645 3.4015804,15.9717 8.8849704,21.4494 5.478,5.4826 13.0832,8.8858 21.4487,8.8842 8.3636,0.0018 15.9707,-3.4016 21.4485,-8.8841 5.4834,-5.4778 8.8868,-13.0849 8.8851,-21.4494 0.0017,-8.154 -3.2322,-15.5907 -8.4768,-21.03309 z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 27.524,27.524 44.476,44.476",
    stroke: "white",
    strokeWidth: 5.45771,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.476,27.524 27.524,44.476",
    stroke: "white",
    strokeWidth: 5.45771,
    strokeLinecap: "round",
    style: {
      fill: "none",
      stroke: "#ffffff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/review_icon.a1c4b64dd7deecdbee2cd92b5bcec058.svg";
export { ForwardRef as ReactComponent };